import React, { Component } from 'react';
import PropTypes from 'prop-types';

// helpers
import AnalyticsUtils from '../../lib/AnalyticsUtils';

const BtnPropTypes = {
  children: PropTypes.node.isRequired, // Can be plain text or additional markup for styling button
  styles: PropTypes.string.isRequired, // Optional classnames for styling the button
  disabled: PropTypes.bool, // Disables the button when true
  analytics: PropTypes.shape({}), // GA helpers
  handleClick: PropTypes.func.isRequired, // Callback method to invoke when button is clicked
};

const BtnDefaultProps = {
  disabled: false,
  analytics: null,
};

class Btn extends Component {
  constructor(props) {
    super(props);

    this.handleBtnClick = this.handleBtnClick.bind(this);
  }

  componentDidUpdate() {
    const { disabled } = this.props;
    const routeBtn = document.getElementsByClassName('route__btn');

    if (!disabled && routeBtn.length) {
      routeBtn[0].focus();
    }
  }

  /**
   * Log button click with analytics if analytics tagging is defined for
   * component instance.
   *
   * @param {object} e - Event object from DOM element
   */
  handleBtnClick(e) {
    const { analytics, handleClick } = this.props;

    if (analytics) AnalyticsUtils.pushInteraction(analytics);

    if (handleClick) handleClick(e);
  }

  render() {
    const { styles, children, disabled } = this.props;

    return (
      <button
        type="button"
        className={styles}
        onClick={e => this.handleBtnClick(e)}
        disabled={disabled}
      >
        {children}
      </button>
    );
  }
}

Btn.propTypes = BtnPropTypes;

Btn.defaultProps = BtnDefaultProps;

export default Btn;
